"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const Set = (key, value, domain, res) => {
    if (res)
        SetFromServer(key, value, res);
    else if (!res && domain)
        SetFromClient(key, value, domain);
};
const SetFromClient = (key, value, domain) => {
    js_cookie_1.default.set(`__${key}__`, JSON.stringify(value), { domain });
};
const SetFromServer = (key, value, res) => {
    if (res.cookie) {
        res.cookie(`__${key}__`, value, {
            maxAge: 60 * 24 * 60 * 60 * 1000
        });
    }
};
const Get = (key, req) => {
    return req ? GetFromServer(key, req) : GetFromClient(key);
};
const GetFromClient = (key) => {
    const value = js_cookie_1.default.get(`__${key}__`);
    return value ? JSON.parse(value) : undefined;
};
const GetFromServer = (key, req) => {
    var _a, _b;
    if (!req.headers || !req.headers.cookie) {
        return undefined;
    }
    const rawCookie = (_b = (_a = req.headers) === null || _a === void 0 ? void 0 : _a.cookie) === null || _b === void 0 ? void 0 : _b.split(';').find((c) => c.trim().startsWith(`__${key}__=`));
    if (!rawCookie) {
        return undefined;
    }
    return JSON.parse(decodeURIComponent(rawCookie.split('=')[1]));
};
const Remove = (key, domain, res) => {
    if (res)
        RemoveFromServer(key, res);
    else if (!res && domain)
        RemoveFromClient(key, domain);
};
const RemoveFromClient = (key, domain) => {
    js_cookie_1.default.remove(`__${key}__`, { domain });
};
const RemoveFromServer = (key, res) => {
    if (res.cookie) {
        res.cookie(`__${key}__`, '', {
            maxAge: 0
        });
    }
};
exports.default = {
    Set,
    Get,
    Remove
};
